import $ from 'jquery';

$('[data-smooth-scroll]').each(function() {
    const target = $($(this).attr('href'));
    let offset = $(this).data('smooth-scroll');

    if (!offset) {
        offset = 250;
    }

    $(this).click(function() {
        $('html, body').animate({
            scrollTop: target.offset().top - offset,
        }, 350);

        return false;
    });
});
